export const ZENDESK_BASE_URL = "https://waffy.zendesk.com/api/v2";
export const CREATE_TICKET_PATH = "/requests";
export const ZENDESK_TOKEN = process.env.REACT_APP_ZENDESK_ACCESS_TOKEN;
export const ESCALATION_REASONS = [
  {
    key: "product_not_delivered",
    value: "lbl_fill_escalation_donot_receive_product",
  },
  {
    key: "product_not_identical_with_description",
    value: "lbl_fill_escalation_product_not_match_desc",
  },
  { key: "product_not_working", value: "lbl_fill_escalation_product_not_work" },
  {
    key: "product_has_cracks_and_defects",
    value: "lbl_fill_escalation_product_is_damged",
  },
];
export const ZENDESK_CONTRACT_SHORT_ID = 5622937763997;
export const ZENDESK_CONTRACT_ID = 8020213825821;
export const ZENDESK_ESCALATION_TYPE = 5695024076957;
export const ZENDESK_ADDITIONAL_REASONS = 5682408486941;
export const ZENDESK_ESCALATION_REASON = 5682283642653;
export const ZENDESK_PHONE_NUMBER = 6369808263453;
export const ZENDESK_ADMIN_URL = 6936675764637;
export const ZENDESK_COMMENT = {
  BODY: "تصعيد لوفي",
};
export const ZENDESK_EMAIL_DOMAIN = process.env.REACT_APP_ZENDESK_EMAIL_DOMAIN;
export const ZENDESK_EXTERNAL_ID_PREFIX =
  process.env.REACT_APP_ZENDESK_EXTERNAL_ID_PREFIX || "";

export const ZENDESK_ADMIN_CONTRACL_BASE_URL =
  process.env.REACT_APP_ADMIN_CONTRACT_URL;
